import { StowagePositionDto } from '@planning/app/api'
import { ContainerJourneyStatusChip } from '@planning/components/molecules/ContainerJourneyStatusChip'
import { TFnType } from '@tolgee/react'
import { TomTableEmptyCell } from '@tom-ui/ui'
import { formatPosition } from '@tom-ui/utils'
import { MRT_ColumnDef } from 'material-react-table'
import { ReactNode } from 'react'
import { RestowListTableColumnsDto } from '../Stores/VesselVisitOrderListViewStore'
import { columnFilterPresets } from './columnFilterConfigs'

export const FormattedStowagePosition = (
  props: { renderedCellValue: ReactNode },
  stowagePosition?: StowagePositionDto | null,
) => {
  if (!stowagePosition) {
    return TomTableEmptyCell(props)
  }

  const formattedPosition = formatPosition(stowagePosition)

  return <>{formattedPosition}</>
}

export const getRestowListColumns = (t: TFnType): MRT_ColumnDef<RestowListTableColumnsDto>[] => [
  {
    accessorKey: 'number',
    header: t('containerNo', 'Container No.'),
    size: 150,
    ...columnFilterPresets.searchMandatory(),
  },
  {
    accessorKey: 'archetype',
    header: t('archetype', 'Archetype'),
    size: 100,
    ...columnFilterPresets.searchMandatory(),
  },
  {
    accessorKey: 'shippingLine',
    header: t('shippingLine', 'Shipping line'),
    size: 150,
    ...columnFilterPresets.searchMandatory(),
  },
  {
    accessorKey: 'cargoStatus',
    header: t('cargoStatus', 'Cargo status'),
    size: 170,
    ...columnFilterPresets.fullEmptySelect(),
  },
  {
    accessorKey: 'pol',
    header: t('pol', 'POL'),
    size: 80,
    Cell: TomTableEmptyCell,
    ...columnFilterPresets.searchOptional(),
  },
  {
    accessorKey: 'pod',
    header: t('pod', 'POD'),
    size: 80,
    Cell: TomTableEmptyCell,
    ...columnFilterPresets.searchOptional(),
  },
  {
    accessorKey: 'grossWeight',
    header: t('grossWeight', 'Gross weight'),
    size: 150,
    ...columnFilterPresets.numericMandatory(),
  },
  {
    accessorKey: 'vgm',
    header: t('vgm', 'VGM'),
    size: 175,
    ...columnFilterPresets.numericMandatory(),
  },
  {
    accessorKey: 'inboundPos',
    header: t('inboundPos', 'Inbound pos.'),
    size: 180,
    Cell: TomTableEmptyCell,
    accessorFn: row => (row.originPosition ? formatPosition(row.originPosition) : undefined),
    ...columnFilterPresets.searchOptional(),
  },
  {
    accessorKey: 'plannedPos',
    header: t('plannedPos', 'Planned pos.'),
    size: 180,
    Cell: TomTableEmptyCell,
    accessorFn: row =>
      row.destinationPosition ? formatPosition(row.destinationPosition) : undefined,
    ...columnFilterPresets.searchOptional(),
  },
  {
    accessorKey: 'outboundPos',
    header: t('outboundPos', 'Outbound pos.'),
    size: 180,
    Cell: TomTableEmptyCell,
    accessorFn: row => (row.actualPosition ? formatPosition(row.actualPosition) : undefined),
    ...columnFilterPresets.searchOptional(),
  },
  {
    accessorKey: 'status',
    header: t('status', 'Status'),
    size: 150,
    ...columnFilterPresets.orderStatusMultiSelect(),
    Cell: cell => <ContainerJourneyStatusChip status={cell.row.original.status ?? '-'} />,
  },
]
